import Col from 'client/components/Col';
import Container from 'client/components/Container';
import React from 'react';
import Row from 'client/components/Row';
import { Button, Heading, Text } from '@indeed/ifl-components';
import { PageNotFound1 } from '@indeed/indeed-design-system-illustrations-hero';
import { useLocalizationContext } from 'client/context/LocalizationContext';

const NotFoundPage = (): React.JSX.Element => {
    const { gt } = useLocalizationContext();

    return (
        <Container sx={{ flex: 1, flexDirection: 'row', textAlign: 'center' }}>
            <Row>
                <Col>
                    <PageNotFound1 sx={{ inlineSize: ['100%', null, null, '25%'] }} />
                    <Heading level={3}>{gt.gettext("We can't find this page.")}</Heading>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Text level={2} as="p">
                        {gt.gettext("It looks like this page doesn't exist or isn't available right now.")}
                    </Text>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button sx={{ marginBlockStart: 1 }} onClick={() => (window.location.href = '/')}>
                        {gt.gettext('Return home')}
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default NotFoundPage;
